<template>
    <div>
        <h5>All Existing Data Sources</h5>
        <div v-if="checkUserPermission(UserPermissions.WRITE_DATASOURCE)" class="card">
            <div class="flex">
                <Button label="Create a Datasource" @click="formDialog = true" />
            </div>
        </div>
        <div>
            <data-source-table />
        </div>
        <data-source-form v-if="formDialog" @hide-dialog="formDialog = false" />
    </div>
</template>

<script setup>
import DataSourceForm from '../modules/DataSourceForm.vue';
import DataSourceTable from '../modules/DataSourceTable.vue';

import { ref } from 'vue';
import useUserComposable from '@/composables/UserComposable';
import { UserPermissions } from '../../../../../enums';

const { checkUserPermission } = useUserComposable();

const formDialog = ref(false);
</script>
